var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValidationRequest = function SvgValidationRequest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10345_110432)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 68.4166 58.9285)",
    fill: "url(#paint2_linear_10345_110432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3812 56.7197C72.3812 57.6097 72.1526 58.6117 71.7244 59.599C71.2961 60.5862 70.6875 61.5144 69.9754 62.2661C69.2633 63.0179 68.4797 63.5594 67.7237 63.8222C66.9678 64.085 66.2734 64.0574 65.7284 63.7427C65.1833 63.428 64.8122 62.8405 64.6618 62.0544C64.5114 61.2683 64.5886 60.3189 64.8836 59.3264C65.1785 58.3338 65.678 57.3426 66.3189 56.4781C66.9598 55.6137 67.7133 54.9147 68.484 54.4697",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.381 53.3449L68.8288 59.4975C68.7835 59.5759 68.7298 59.6484 68.6707 59.7108C68.6116 59.7732 68.5482 59.8244 68.4842 59.8613C68.4202 59.8983 68.3568 59.9203 68.2977 59.9261C68.2386 59.932 68.1849 59.9215 68.1396 59.8954L67.0244 59.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6229 61.7913L58.8485 59.4217C58.3016 59.106 57.9406 58.5003 57.8166 57.6903C57.6927 56.8802 57.8122 55.907 58.1581 54.9085V54.9085C58.4192 54.1548 58.8007 53.4119 59.2711 52.741C59.7415 52.0701 60.2873 51.4904 60.8636 51.0498C61.4399 50.6092 62.0302 50.3202 62.5857 50.2067C63.1413 50.0932 63.6463 50.1584 64.059 50.3969L65.0761 50.9834L66.0933 49.2224C66.506 48.5073 67.0109 47.859 67.5665 47.331C68.1221 46.803 68.7123 46.4104 69.2886 46.1856C69.8649 45.9608 70.4108 45.9101 70.8812 46.0379C71.3516 46.1656 71.7331 46.4681 71.9942 46.9203V46.9203C72.252 47.3673 72.3853 47.9478 72.3831 48.6152C72.381 49.2825 72.2435 50.0182 71.9818 50.7629",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110432",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.243137 0 0 0 0 0.501961 0 0 0 0 0.988235 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110432",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45ABFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C76FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110432",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110432",
    x1: 9,
    y1: 8.9975,
    x2: -0.705772,
    y2: 0.839694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110432",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E7CFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10345_110432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 57.2817 52.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValidationRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "validation_request.d38dfa742e71aadcb9c3c7fddc66d7a4.svg";